import React from "react";
import Dropdown from "./Dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { FaCogs, FaUserAlt, FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import noProfilePic from "../../assets/img/auth/noProfilePic.avif";

const Navbar = (props) => {
  const { onOpenSidenav } = props;
  let navigate = useNavigate();

  const storedData = localStorage.getItem("Ananya Enterprize-Users-Data");

  //Converting the fetched user details into JSON
  const userData = storedData ? JSON.parse(storedData) : {};
  console.log("User Data: ", userData);
  return (
    <nav className="sticky top-4 z-40 mx-2 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white px-2 shadow-md">
      <div className="ml-4 hidden xl:block">
        <FaCogs size={36} color="#3B3B3D" />
      </div>
      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-between gap-2 bg-white px-2 py-2 dark:!bg-navy-800 dark:shadow-none md:w-full md:flex-grow-0 md:gap-1 xl:w-[365px] xl:justify-end xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-8 w-8" />
        </span>

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-12 w-12 rounded-full"
              src={userData?.profilePic || noProfilePic}
              alt="avatar"
            />
          }
          children={
            <div className="flex w-48 flex-col items-center rounded-2xl bg-white tracking-wide shadow-lg shadow-gray-300">
              <div className="flex w-full flex-col space-y-3 p-4">
                <div
                  onClick={() => navigate("/admin/user-profile")}
                  className="flex w-full cursor-pointer items-center justify-center rounded-lg bg-[#f6ecfb] py-3 text-sm font-semibold text-gray-700 shadow-md transition-all hover:bg-primary hover:text-white"
                >
                  <FaUserAlt className="mr-2" />
                  <span>Profile</span>
                </div>

                <button
                  onClick={() => {
                    localStorage.clear();
                    navigate("/auth/sign-in");
                  }}
                  className="flex w-full cursor-pointer items-center justify-center rounded-lg bg-[#f6ecfb] py-3 text-sm font-semibold text-gray-700 shadow-md transition-all hover:bg-red-500 hover:text-white"
                >
                  <FaSignOutAlt className="mr-2" />
                  <span>Log Out</span>
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[120px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
